import { queryExtendedBookings } from '../../api/queryExtendedBookings/queryExtendedBookings';
import { AsyncComponentDataStatus } from '../../../components/DailyAgenda/state/types';
import { InitiatorsArgs } from '../initWidgetData';
import type { IHttpError } from '@wix/http-client';

export const initBookings = async ({
  flowAPI,
  setState,
  getState,
}: InitiatorsArgs) => {
  try {
    if (
      flowAPI.controllerConfig.wixCodeApi.user.currentUser.loggedIn === false
    ) {
      return;
    }
    const { selectedFilters: filters } = getState();

    const { extendedBookings, pagingMetadata } = await queryExtendedBookings({
      flowAPI,
      filters,
    });

    setState({
      bookedSlots: {
        status: AsyncComponentDataStatus.IDLE,
        data: (extendedBookings || [])?.map(
          (extendedBooking) =>
            extendedBooking.booking?.bookedEntity?.slot?.eventId!,
        ),
      },
      bookedSlotsMetaData: {
        status: AsyncComponentDataStatus.IDLE,
        data: pagingMetadata,
      },
    });
  } catch (error) {
    setState({
      bookedSlots: {
        status: AsyncComponentDataStatus.ERROR,
        data: (error as IHttpError).response?.data,
      },
    });
    console.error('Failed to initialize bookings:', error);
  }
};
